import { useAuth0 } from "@auth0/auth0-react";
import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { useInvoicesQuery } from "~/graphql/graphql-new.gen";
import type { InvoiceUpdatedSubscription } from "~/graphql/graphql.gen";
import { InvoiceUpdatedDocument } from "~/graphql/graphql.gen";

import { activeSaleState } from "../stores/sales";
import { getSubscriptionClient } from "./subscription-client";

export const useInvoiceUpdatedSubscription = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const activeSale = useAtomValue(activeSaleState);

  useEffect(() => {
    const client = getSubscriptionClient(getAccessTokenSilently);
    const subscribe = () => {
      client
        .request({
          query: InvoiceUpdatedDocument,
        })
        .subscribe({
          next(response) {
            if (!activeSale) return;

            const data = response.data as InvoiceUpdatedSubscription;

            if (!data.invoiceUpdated) return;

            queryClient.invalidateQueries({
              queryKey: useInvoicesQuery.getKey({ saleId: activeSale.id }),
            });
          },
        });
    };
    subscribe();
    return () => {
      client.close();
    };
  }, [queryClient, activeSale]);
};
